import { useCallback, useState } from 'react';
import createUseContext from 'constate';
import firebase from '../../preorder/services/firebase';
import { getActivities } from '../api/activity';

const path = `/${process.env.REACT_APP_MODE}/activities/data`;
const activitiesRef = firebase.database().ref(path);

const useActivity = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activities, setActivities] = useState([]);

  const loadActivities = useCallback(async () => {
    setIsLoading(true);

    try {
      await getActivities();
    } catch (e) {
      // ignore the error
      console.log(e.message);
    }

    try {
      const snapshot = await activitiesRef.once('value');
      const data = snapshot.val();
      setActivities(data || []);
    } catch (e) {
      // ignore the error
      console.log(e.message);
    }

    setIsLoading(false);
  }, [setIsLoading]);

  return {
    activities,
    isLoading,
    loadActivities,
  };
};

const [ActivityProvider, useActivityContext] = createUseContext(useActivity);

export {
  ActivityProvider,
  useActivityContext,
};
